module.exports = __webpack_public_path__ + "static/media/pencil.d595f44b.svg";